import { Component, OnInit, ViewEncapsulation, Output, Input, EventEmitter} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { LocalStorage, LocalStorageService } from 'ngx-store';
import { saveAs } from 'file-saver';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ImageResult } from 'ngx-image2dataurl';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import * as moment from "moment";

//Model
import { Url, ThemeSetting, User, UserFile } from '../../model/users.model';
import { FileExport } from '../../model/exporter.model';


//Services
import { InductionService} from '../../services/inductions.service';
import { ExportService } from '../../services/exporter.service';
import { PrintService } from '../../services/print.service';
import { UsersService } from '../../services/users.service';
import { FilesService } from '../../services/files.service';
import { NotificationService } from '../../services/notification.service';
import { DriversService } from '../../services/drivers.service';


import { formatDate } from '@angular/common';

@Component({
    selector: 'app-userfiles',
    templateUrl: './userfiles.component.html',
    styleUrls: ['../datatable.scss', './userfiles.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [ InductionService ],
    exportAs: 'app-userfiles',

  })
  
  export class UserFilesComponent implements OnInit {    
    @LocalStorage() url!: Url;
    @Input() user_id: number;
    @Input() display_name: string;
    @Input() origin: string;
    @Output() refreshRootData : EventEmitter<any>= new EventEmitter<any>();

    public modalRef: NgbModalRef;
    frmUserFile: FormGroup;
    verifiedFiles: UserFile[];
    vCount: number = 0;
    unverifiedFiles: UserFile[];
    uCount: number = 0;
    userFile: UserFile;
    isAdmin: boolean = false;
    spinner: boolean = false;
    loadingIndicator: boolean = true;
    public files: any[];
    public pic1 = true;
    public requiredPic: boolean = true;
    public newUploadPic: boolean = true;
    spinner2: boolean = false;
    public folderPath : string;
    public readonly fileStoragePath = this.url.fileStorage;
    uploadFolder: string;
    current_user_login: number;

    public myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd mmm yyyy', 
        height: '24px'
      };
    public placeholder = "Select a Date"
    
    //Handles the name, type and content of the to-be exported file
    public exp_excel: FileExport;
    public exp_pdf: FileExport;

    //Stores the filtered and formatted content of the file
    formatted_list : any;

    columns2 = [
        { name: 'Operations', prop: 'id'  },
        { name: 'Date Added', prop: 'date_added'},
        { name: 'Description', prop: 'description'},
        { name: 'File', prop: 'filename'},
        { name: 'Expiry', prop: 'expiry'},
        { name: 'is_expiry', prop: 'is_expiry'},
        { name: 'induction_record_status', prop: 'induction_record_status'},
        { name: 'induction_tasks_title', prop: 'induction_tasks_title'}
    ]

    document_tasks: any;
    
    constructor(private http: HttpClient, 
                private inductionService: InductionService,
                public printer: PrintService,
                private svc_storage: LocalStorageService,
                private modalService: NgbModal,
                public svc_user: UsersService,
                private fileService: FilesService,
                private formBuilder: FormBuilder,
                private exporter: ExportService,
                private toastr: NotificationService,
                public svc_driver: DriversService,
                ){
              
    }

    ngOnInit() {
      //Declaration to handle the name, type and content of the file
      this.exp_excel = { title: '', list_data: '', type: '' };
      this.exp_pdf = { title: '', list_data: '', type: '' };
      
      if(this.origin == 'user'){
          this.folderPath = this.fileStoragePath + '/user_files/';
          this.uploadFolder = 'user_files';
      };

      this.current_user_login = this.svc_storage.get('user').id;
      this.getFiles(this.user_id, this.filterDropdown);
      this.initializeData();

      if (this.svc_storage.get('user').role_id == '1' || this.svc_storage.get('user').role_id == '9') {
        this.isAdmin = true;
      }
    }

    openFileModal(modalName, userFile: UserFile) {
      this.userFile = userFile;
  
      if (modalName == 'mCreateUserFile') {
        this.modalRef = this.modalService.open(modalName, { container: '.app', size: 'lg', backdrop: 'static' });
      } else {
        this.modalRef = this.modalService.open(modalName, { container: '.app', backdrop: 'static' });
      }
    }


    private closeFileModal() {
        this.userFile = null;
        this.modalRef.close();
    }
    
    async updateViewFile(userFile: UserFile, value: number) {
    this.spinner = true;
    this.userFile = userFile;
    this.userFile.is_viewable = value;
    this.userFile.updated_by = this.current_user_login;

    await this.svc_user.updateUserFile(userFile).toPromise().then(result => {
      this.toastr.showSuccess(result["message"], 'Update File');
      }, error => {
          this.toastr.showError("Please try again. There was a problem with updating the selected file.",'Update File');
      });
      this.spinner = false;
    }

    async verifyFile(userFile: UserFile) {
      this.spinner2 = true;
      this.userFile = userFile;
      this.userFile.updated_by = this.current_user_login;

      await this.svc_user.verifyUserFile(this.userFile).toPromise().then(result => {
          this.toastr.showSuccess(result["message"], 'Verify File');
          this.getFiles(this.user_id, this.filterDropdown);
      }, error => {
          this.toastr.showError("Please try again. There was a problem with verifying the selected file.", 'Verify File');
      });
      this.spinner2 = false;
    }


    async onSubmitUserFile(userFile: UserFile) {
      this.spinner = true;
      if (this.frmUserFile.valid) {
        this.userFile = userFile;
        this.setMydatePickerDateFormatsFormFile();
        this.userFile.user_id = this.user_id;

        if (this.isAdmin) {
          this.userFile.verified = 1;
        }
        
        await this.svc_user.createUserFile(this.userFile).toPromise().then(results => {
          this.toastr.showSuccess(results['message'] + '. This is added in files list table', 'Add File');
          this.userFile = results["data"];

          }).catch(err => {
              this.toastr.showError("Please try again. There was a problem with creating new contact entry.", 'Add File');
          }).finally(() => {
              this.uploadFile(this.userFile);
              this.getFiles(this.user_id, this.filterDropdown);
          });
      }
      this.closeModal();
      this.spinner = false;
      this.modalReset();
      this.refreshRootData.emit();

    }


    public frmFile: any;
    public bfm_file: any;

    async uploadFile(userFile: UserFile) {
      if (this.frmFile) {
          await this.fileService.uploadRawFileWithRename(this.uploadFolder, this.frmFile, userFile.filename).toPromise().then(file => {
          console.log('file uploaded....');

          if (file["data"] !== this.userFile.filename) {
              this.userFile.filename = file["data"];
              this.svc_user.updateUserFile(this.userFile).subscribe(data => {
              this.getFiles(this.user_id, this.filterDropdown);
              });
          }
          this.getFiles(this.user_id, this.filterDropdown);
          });

      }

      this.frmFile = '';
      this.initializeData();
    }


    uFiles = [];
    uFileCount : number = 0;
    selected = [];
    selected_file = [];
  
    public getFiles(id: number, filter:string) {
      this.loadingIndicator = true;

      if (filter == 'unverified'){
        this.svc_user.getUnverifiedUserFilesByUserId(id).subscribe(data => {
          if (data['userFiles'].length > 0) {
            this.uFiles = data["userFiles"];
            this.uFileCount = this.uFiles.length;
            this.uFiles = [...this.uFiles];
            this.selected_file = [data["userFiles"][0]];
          } else {
            this.uFileCount = 0;
          }
          setTimeout(() => { this.loadingIndicator = false; }, 500);
        })
      }
      if (filter == 'files'){
        this.svc_user.getVerifiedUserFilesByUserId(id).subscribe(data => {
          if (data['userFiles'].length > 0) {
            this.uFiles = data["userFiles"];
            this.uFileCount = this.uFiles.length;
            this.uFiles = [...this.uFiles];
            this.selected_file = [data["userFiles"][0]];
          } else {
            this.uFileCount = 0;
          }
          setTimeout(() => { this.loadingIndicator = false; }, 500);
        });
      }

      if (filter == 'all' || filter == 'archived'){
        this.svc_user.getUserFilesByUserId(id).subscribe(data => {
          if (data['userFiles'].length > 0) {
            this.uFiles = data["userFiles"];
            this.uFileCount = this.uFiles.length;

            if(filter == 'archived'){
              this.uFiles = this.uFiles.filter(row => {
                return (row.is_expired == 1 || row.induction_record_status == 4); 
              })
  
              if(this.uFiles.length > 0){
                this.uFileCount = this.uFiles.length;
                this.selected_file = [this.uFiles[0]];
                this.uFiles = [...this.uFiles];
              };
  
            }else{
              this.uFileCount = this.uFiles.length;
              this.uFiles = [...this.uFiles];
              this.selected_file = [data["userFiles"][0]];
            };
  
          } else {
            this.uFileCount = 0;
          }
          setTimeout(() => { this.loadingIndicator = false; }, 500);
        });
      };
      
      //get remaining doc tasks
      this.svc_driver.getDocumentUploadTask(this.user_id).subscribe(data=>{
        this.document_tasks = data['document_tasks'];
      });

    }

    filterDropdown: string = 'all';
    onChangeFilterDropdown(selected) {
      this.loadingIndicator = true;
      if (selected) {
          this.getFiles(this.user_id, selected);
      }
    }

    public initializeData() {
      let d: Date = new Date();
      const specialNumber = "^(?=.*[0-9])[- +()0-9]+$";
      const rateNumber = "^[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$";
      const email = "^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,12}$";
      const numbers = '^[0-9]+$';
      this.files = [{ name: ' ', blob: ' ' }];
  
      this.frmUserFile = this.formBuilder.group({
        id: [''],
        user_id: [this.user_id],
        verified: [0],
        is_viewable: [0],
        induction_task_id: [''],
        filename: [''],
        expiry: [''],
        description: ['', Validators.required],
        date_added: ['', Validators.required],
        created_by: [this.current_user_login],
        updated_by: [null],
      });
    }
    

    private setMydatePickerDateFormatsFormFile() {
      if (this.isValidDate(this.userFile.date_added)) {
          let date_added = this.userFile.date_added['date'].year + '-' + this.userFile.date_added['date'].month + '-' + this.userFile.date_added['date'].day;
          this.userFile.date_added = date_added;
      }

      if (this.isValidDate(this.userFile.expiry)) {
          let expiry = this.userFile.expiry['date'].year + '-' + this.userFile.expiry['date'].month + '-' + this.userFile.expiry['date'].day;
          this.userFile.expiry = expiry;
      }
    }

  
    public closeModal() {
      this.modalRef.close();
      this.pic1 = true;
      this.requiredPic = true;
      this.newUploadPic = true;
  
    }

    isValidDate(date_value):boolean{
      if (date_value != '0000-00-00' && date_value != '' && date_value != null){
        return true;
      }else{
        return false
      } 
    }

    public getFile(event, type: string) {
      this.requiredPic = true;
      this.newUploadPic = true;
  
      if(event == '' || event==null){
        if(type = "user") {
          this.frmFile = event;
          this.frmUserFile.controls.filename.setValue(event);
        };
      }else{
        var pictureFile: ImageResult;
        pictureFile = event;

        this.frmFile = event;
        this.frmUserFile.controls.filename.setValue(pictureFile.file.name);
      }
    }


    onDateChanged(event: IMyDateModel, obj_name: string) {
      switch (obj_name) {
          case 'date_added': { if (this.frmUserFile.controls.date_added.setValue(event.jsdate) != undefined) this.frmUserFile.controls.date_added.setValue(event.jsdate); break; }
          case 'expiry': { if (this.frmUserFile.controls.expiry.setValue(event.jsdate) != undefined) this.frmUserFile.controls.expiry.setValue(event.jsdate); break; }

          default: break;
      }

    }

    /*** Export... Module ***/
    //Replaces an attribute name for reading comprehension
    renameKey( obj, oldKey, newKey ) {
      obj[newKey] = obj[oldKey];
      delete obj[oldKey];
        
    }

    //Formats readable header names in the given table
    generateHeaders(list_files): any{
      const arr = JSON.parse(list_files);
      arr.forEach( obj => {
          this.renameKey( obj, 'date_added', 'Date Added' );
          this.renameKey( obj, 'description', 'Description' );
          this.renameKey( obj, 'filename', 'File' );
          this.renameKey( obj, 'expiry', 'Expiry' );
          this.renameKey( obj, 'verified', 'Is Verified' );
          this.renameKey( obj, 'is_viewable', 'Is Viewable' );
          this.renameKey( obj, 'induction_tasks_title', 'Induction Task' );
          this.renameKey( obj, 'created_name', 'Created By' );
          this.renameKey( obj, 'updated_name', 'Updated By' );
          this.renameKey( obj, 'created_at', 'Created Date' );
          this.renameKey( obj, 'updated_at', 'Updated Date' );
      });
      const updatedJson = JSON.stringify( arr );
      return updatedJson;
    }

    //Filters every column in the table list
    file_generateColumnsWithFilter(list_files){
      const arr = JSON.parse(JSON.stringify(list_files));
      arr.forEach( obj => {
          delete obj['id'];
          delete obj['user_id'];
          delete obj['induction_task_id'];
          delete obj['created_by'];
          delete obj['updated_by'];
          delete obj['induction_record_id'];
          delete obj['is_expired'];
          delete obj['induction_record_status'];
  
          if (obj['created_at'] == '0000-00-00 00:00:00' || obj['created_at'] == null || obj['created_at'] == "")
            obj['created_at'] = 'No Date';
          else
            obj['created_at'] = formatDate(obj['created_at'], 'dd MMM yyyy h:mm a', 'en_US');
  
          if (obj['updated_at'] == '0000-00-00 00:00:00' || obj['updated_at'] == null || obj['updated_at'] == "")
            obj['updated_at'] = 'No Date';
          else
            obj['updated_at'] = formatDate(obj['updated_at'], 'dd MMM yyyy h:mm a', 'en_US');
  
          if (obj['date_added'] == '0000-00-00' || obj['date_added'] == null || obj['date_added'] == "")
            obj['date_added'] = 'No Date';
          else
            obj['date_added'] = formatDate(obj['date_added'], 'dd MMM yyyy', 'en_US');
  
          if (obj['expiry'] == '0000-00-00' || obj['expiry'] == null || obj['expiry'] == "")
            obj['expiry'] = 'No Date';
          else
            obj['expiry'] = formatDate(obj['expiry'], 'dd MMM yyyy', 'en_US');
  
          if(obj['verified'] == 1){
            obj['verified'] = 'True';
          }else{
            obj['verified'] = 'False';
          }
  
          if(obj['is_viewable'] == 1){
            obj['is_viewable'] = 'True';
          }else{
            obj['is_viewable'] = 'False';
          }
      });
      const updatedJson = JSON.stringify( arr );
      return updatedJson;                         
    }

    //Exports table to CSV file
    file_exportToCSV(){
      if(this.uFiles.length >0){
          let with_header_format, with_column_filter;
          
          //generate json with filtered column
          with_column_filter = this.file_generateColumnsWithFilter(this.uFiles);

          //generate json with format header
          this.formatted_list = this.generateHeaders(with_column_filter);

          //export to file
          let current_date = new Date();
          let csv_file = '[TMS]UserFiles_' + this.formattedDate(current_date);
          this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Driver Files');
      }
    };

    //Exports table to PDF file
    file_exportToPDF(){
      if(this.uFiles.length >0){
      let with_header_format, with_column_filter;

      //generate json with filtered column
      with_column_filter = this.file_generateColumnsWithFilter(this.uFiles);

      //generate json with format header
      this.formatted_list = this.generateHeaders(with_column_filter);

      //export to file
      let current_date = new Date();
      let pdf_file = '[TMS]UserFiles_' + this.formattedDate(current_date);
      this.exp_pdf.title = 'USER FILES';
      this.exp_pdf.type = 'pdf';
      this.exp_pdf.list_data = this.formatted_list;
      this.exporter.exportToPDF(this.exp_pdf).subscribe(data=>{
          saveAs(data, pdf_file + '.' + this.exp_pdf.type);
      });
      }
    };

    //Exports table to MS Excel file
    file_exportToExcel(){
      if(this.uFiles.length >0){
          let with_header_format, with_column_filter;
          
          //generate json with filtered column
          with_column_filter = this.file_generateColumnsWithFilter(this.uFiles);

          //generate json with format header
          this.formatted_list = this.generateHeaders(with_column_filter);

          //export to file
          let current_date = new Date();
          let excel_file = '[TMS]UserFiles' + this.formattedDate(current_date);
          this.exp_excel.title = 'USER FILES';
          this.exp_excel.type = 'xlsx';
          this.exp_excel.list_data = this.formatted_list;
          this.exporter.exportToExcel(this.exp_excel).subscribe(data=>{
              saveAs(data, excel_file)
          });
      }
    }; 

    //Returns a date format in the file name
    public formattedDate(d = new Date) {
      let month = String(d.getMonth() + 1);
      let day = String(d.getDate());
      const year = String(d.getFullYear());
  
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
  
      return `${day}/${month}/${year}`;
    }

    public formatDate(inDate: string) {
      let formatedDate: Date;
      
      if(moment(moment(inDate).format('L'), 'MM/DD/YYYY').isValid()){
        if (inDate !== null && inDate !== '' && inDate !== '0000-00-00') {
          if (inDate.toString().indexOf('-') > 0) { formatedDate = new Date(inDate.toString().replace(/-/g, "/")); }
        }
      }
  
      return formatedDate;
    }

    async deleteFile(userFile: UserFile) {
      this.loadingIndicator = true
      this.spinner = true;
  
      await this.svc_user.deleteUserFile(userFile.id, this.current_user_login, userFile.user_id).toPromise().then(data => {
        if(userFile.filename!='' && userFile.filename != null){
          this.fileService.deleteFile(this.origin, userFile.filename).subscribe(data => {
            this.toastr.showSuccess(data["message"], 'Delete File');
            this.getFiles(this.user_id, this.filterDropdown);
          }, error => {
            this.toastr.showError("Please try again. There was a problem with deleting the selected file.", 'Delete File');
          });
        }else{
          this.toastr.showSuccess('Successfully deleted this file.', 'Delete File');
          this.getFiles(this.user_id, this.filterDropdown);
        }
        
      });
  
      this.closeModal();
      this.spinner = false;
      this.refreshRootData.emit();
      setTimeout(() => { this.loadingIndicator = false; }, 500);
    }

    getCellClassDoc({ row, column, value }): any {
      return {
        'is-verified': row.verified == 1,
        'is-unverified': row.verified == 0,
      };
    }

    modalReset(){
      this.frmUserFile.reset();
      this.frmFile?.reset();
    }


    
  }